<template>
	<div v-loading="loading" class="onboarding">
		<div class="onboarding-content">
			<div class="onboarding-content-logo"></div>
			<h1>
				Change password
			</h1>
			<el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="handleSubmit('form')">
				<el-form-item prop="password">
					<el-input v-model="form.password" suffix-icon="el-icon-lock" type="password" ref="password" placeholder="New password"></el-input>
				</el-form-item>
				<el-form-item prop="password_confirmation">
					<el-input v-model="form.password_confirmation" suffix-icon="el-icon-lock" type="password" placeholder="Confirm new password"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="flex-between">
						<router-link to="/login">
							<i class="el-icon-arrow-left"></i>Back to login
						</router-link>
						<el-button native-type="submit" type="primary" :loading="loading" plain>Update</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapState } from 'vuex'
import { HTTP } from '@/services/api'

export default {
	name: 'ResetPassword',
	metaInfo () {
		return {
			title: 'Reset password'
		}
	},
	data() {
		return {
			api: process.env.VUE_APP_API,
			loading: true,
			form: {
				password: '',
				password_confirmation: '',
				token: '',
				email: '',
			},
			rules: {
				password: [
					{ required: true, message: 'Please enter new password', trigger: 'blur' },
				],
				password_confirmation: [
					{ validator: this.checkPassword, trigger: 'blur' },
				]
			}
		}
	},
	computed: {
        ...mapState(['auth'])
	},
	mounted () {
		if (this.auth.access_token) {
			this.$router.push('/analytics')
		} else {
			this.form.token = this.getUrlVars()['token']
			this.form.email = this.getUrlVars()['email']
			this.form.email = this.form.email.replace('%40', '@')
			Vue.nextTick(() => {
				this.$refs.password.focus()
			})
			this.loading = false
		}
	},
	methods: {
		checkPassword (rule, value, callback) {
			if (value === '' || value === undefined) {
				callback(new Error('Please confirm new password'))
			} else {
				if (value !== this.form.password) {
					callback(new Error('Please confirm new password'))
				} else {
					callback()
				}
			}
		},
		handleSubmit (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					axios({
						method: 'POST',
						url: this.api + '/api/password/reset',
						crossdomain: true,
						data: this.form
					})
					.then(response => {
						if (response.data.status === 'success') {
							this.handleLogin()
						} else {
							this.loading = false
							this.$notify({
								title: 'Error',
								message: response.data.message ? response.data.message : 'An error occured, please try later',
								type: 'error',
								position: 'bottom-right',
								duration: 3500
							})
						}
					})
					.catch(error => {
						this.loading = false
						this.$notify({
							title: 'Error',
							message: error.response.data.message ? error.response.data.message : 'An error occured, please try later',
							type: 'error',
							position: 'bottom-right',
							duration: 3500
						})
					})
				} else {
					return false
				}
			})
		},
		handleLogin () {
			this.loading = true
			let formData = new FormData()
			formData.append('grant_type', 'password')
			formData.append('client_id', process.env.VUE_APP_CLIENT_ID)
			formData.append('client_secret', process.env.VUE_APP_CLIENT_KEY)
			formData.append('username', this.form.email)
			formData.append('password', this.form.password)
			axios({
				method: 'POST',
				url: this.api + '/oauth/token',
				crossdomain: true,
				data: formData
			})
			.then(response => {
				this.$store.dispatch('setAuth', response.data).then(() => {
					this.loadUserData()
				})
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		loadUserData () {
			HTTP({
				method: 'GET',
				url: '/users/me',
				crossdomain: true
			})
			.then(response => {
				this.$store.dispatch('setUser', response.data).then(() => {
					this.$router.push('/analytics')
				})
			})
		},
		getUrlVars: function() {
			let vars = {}
			window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
			function(m,key,value) {
				vars[key] = value
			})
			return vars
		}
	}
}
</script>
